export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0A]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-4">
          <img src="/images/logo.webp" alt="Taha Developers" className="h-12 w-12 object-cover rounded-full border border-[#C5A059]/40" />
          <div>
            <p className="font-display tracking-wide">TAHA DEVELOPERS</p>
            <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-zinc-500 mt-1">Where Dreams Become Reality</p>
          </div>
        </div>
        <p className="text-zinc-500 text-sm">Dahod, Gujarat, India</p>
        <div className="flex items-center gap-6">
          <p className="font-accent text-[10px] tracking-[0.2em] uppercase text-zinc-600">© {new Date().getFullYear()} Taha Developers</p>
          <a href="/admin/login" className="font-accent text-[10px] tracking-[0.2em] uppercase text-zinc-600 hover:text-[#C5A059] transition-colors" data-testid="footer-admin-link">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
